import { render, staticRenderFns } from "./ReportedItemList.vue?vue&type=template&id=63cc243e&scoped=true"
import script from "./ReportedItemList.vue?vue&type=script&lang=js"
export * from "./ReportedItemList.vue?vue&type=script&lang=js"
import style0 from "./ReportedItemList.vue?vue&type=style&index=0&id=63cc243e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cc243e",
  null
  
)

export default component.exports